import { render, staticRenderFns } from "./SubCustomersDetails.vue?vue&type=template&id=2642634b&scoped=true"
import script from "./SubCustomersDetails.vue?vue&type=script&lang=js"
export * from "./SubCustomersDetails.vue?vue&type=script&lang=js"
import style0 from "./SubCustomersDetails.vue?vue&type=style&index=0&id=2642634b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2642634b",
  null
  
)

export default component.exports